import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KeywordSearchComponent } from '../../../master-search-group/keyword-search/keyword-search.component';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import { PincodeDetailsData } from '../../../services/raintree/interfaces/pincode';
import { AsyncPipe, CommonModule, formatDate } from '@angular/common';
import { KeywordSearchRequest } from '../../../services/raintree/interfaces/keyword-search';
import { KeywordMobileViewPopupComponent } from '../../../master-search-group/keyword-mobile-view-popup/keyword-mobile-view-popup.component';
import { SearchStatusPopupComponent } from '../../../master-search-group/search-status-popup/search-status-popup.component';
import { AuthService } from '../../../services/auth/auth-service';
import { Router } from '@angular/router';
import { KeywordSearchService } from '../../../services/raintree/Transmission/keyword-search.service';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { RitwikTransmissionService } from '../../../services/raintree/Transmission/ritwik.transmission.service';
import { SatesListService } from '../../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../../services/raintree/Transmission/district-list.service';
import { SnackbarService } from '../../../services/common/snackbar.service';
import { ToastrService } from 'ngx-toastr';
import { PincodeDetailsService } from '../../../services/raintree/Transmission/pincode-details.service';
import { StatusResolverService } from '../../../services/raintree/Transmission/status-resolver.service';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { DpLoaderComponent } from '../../../common-component/dp-loader/dp-loader.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DpDatepickerComponent } from '../../../common-component/dp-datepicker/dp-datepicker.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
@Component({
  selector: 'app-keyword-search-tab-responsive',
  standalone: true,
  imports: [
    CommonModule,
    DpTableComponent,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    AsyncPipe,
    MatSelectModule,
    DpLoaderComponent,
    MatFormFieldModule,
    MatInputModule,
    DpDatepickerComponent,
    MatIconModule,
    MatButtonModule,
    LoaderComponent,
    InfiniteScrollModule,
    MatBottomSheetModule,
  ],
  templateUrl: './keyword-search-tab-responsive.component.html',
  styleUrl: './keyword-search-tab-responsive.component.scss'
})
export class KeywordSearchTabResponsiveComponent {
  
  keywordSearchForm!: FormGroup;
  private statusArray: any = [];
  public isMobileDevice: boolean = false;
  public isLoading: boolean = false;
  public enableRowClick: boolean = true;
  public isLoader: boolean = false;
  public pageNo = 1;
  public pageSize = 200;
  @Output() serialNo: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _authService: AuthService,
    private router: Router,
    private keywordSearchService: KeywordSearchService,
    private _commonUtilService: CommonUtilService,
    public ritwikTransmissionService: RitwikTransmissionService,
    public stateTransmissionService: SatesListService,
    public districtTransmissionService: DistrictListService,
    private snackbar: SnackbarService,
    private toaster: ToastrService,
    private _pincodeDetails: PincodeDetailsService,
    private getstatusservice: StatusResolverService,
    private isMobile: CommonUtilService,
    private dialog: MatDialog,
    private _bottomSheet: MatBottomSheet,
  ) {
    this.keywordSearchForm = new FormGroup({
      firstName: new FormControl(''),
      middleName: new FormControl(''),
      lastName: new FormControl(''),
      guardian_first_name: new FormControl(''),
      guardian_middle_name: new FormControl(''),
      guardian_last_name: new FormControl(''),
      ritwiki_first_name: new FormControl(''),
      ritwiki_middle_name: new FormControl(''),
      ritwiki_last_name: new FormControl(''),
      mship_date: new FormControl(''),
      pinCode: new FormControl(''),
      address: new FormControl('', [Validators.minLength(10)]),
      state_name: new FormControl(''),
      district_name: new FormControl(''),
      fullName: new FormControl(''),
      pageNo: new FormControl(1),
      pageSize: new FormControl(100),
    });
  }

  callApiService() {
    this.getstatusservice.getStatusData().subscribe({
      next: (response: any) => {
        console.log(response);
        this.statusArray = response.data;
      },
      error: (error: any) => {},
    });
  }

  ngOnInit(): void {
    // this.keywordSearchForm.value;
    this.keywordSearchForm.get('state_name')?.setValue('');
    this.keywordSearchForm.get('district_name')?.setValue('');

    console.log(this.keywordSearchForm.value);
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.callRtService();
    this.getStatesDistrictList();
    this.callApiService();
  }

  stateList: any = [];
  public isStateReadonly: boolean = false;
  public isDistrictReadonly: boolean = false;
  districtList: any = [];
  searchedDataResponse: boolean = false;
  numberOfLoaders: number = 15;
  ritwikNames: any = [];

  public datatable: any = [];

  public tabLists: any = [];
  public isReadonly: boolean = false;
  public formValidationError: boolean = false;

  // table data schema
  public displayColumnData: any = [
    {
      id: 'mk',
      name: 'Serial No.',
    },
    {
      id: 'rs',
      name: 'Mem Status',
    },
    {
      id: 'dn',
      name: 'District',
    },
    {
      id: 'fullName',
      name: 'Name',
    },
    {
      id: 'guardianName',
      name: 'Guardian',
    },
    {
      id: 'md',
      name: 'Initiation Date',
    },
    {
      id: 'rn',
      name: 'Ritwik',
    },
    {
      id: 'pn',
      name: 'Pincode',
    },
    {
      id: 'add',
      name: 'Address',
    },
  ];

  getControl(name: any): AbstractControl | null {
    return this.keywordSearchForm.get(name);
  }

  columnConfs = {
    add: { cssClass: 'width-250px' },
    updatedOn: { cssClass: 'width-60px' },
    mk: { cssClass: 'slnowidth' },
  };

  clearSelection(event: Event) {
    this.districtList = [];
    this.keywordSearchForm.patchValue({
      firstName: '',
      middleName: '',
      lastName: '',
      guardian_first_name: '',
      guardian_middle_name: '',
      guardian_last_name: '',
      ritwiki_first_name: '',
      ritwiki_middle_name: '',
      ritwiki_last_name: '',
      mship_date: '',
      pinCode: '',
      address: '',
      state_name: '',
      district_name: '',
      fullName: '',
    });
    // this.keywordSearchForm.reset();
  }
  clearStateSelection(event: Event) {
    this.districtList = [];
    event.stopPropagation();
    this.keywordSearchForm.get('state_name')?.setValue('');
    this.keywordSearchForm.get('district_name')?.setValue('');
  }

  clearDistrictSelection(event: Event) {
    event.stopPropagation();
    this.keywordSearchForm.get('district_name')?.setValue('');
  }

  callRtService() {
    this.keywordSearchForm
      .get('ritwiki_first_name')
      ?.valueChanges.pipe(
        debounceTime(300), // wait for 300ms after each keystroke
        filter((value) => typeof value === 'string' && value.length >= 4), // only proceed if value is a string and has exactly 3 characters
        distinctUntilChanged(), // ensure the value has changed
        switchMap(async (term) => this.searchRitwikName(term)) // switch to new observable for API call
      )
      .subscribe((data) => {
        console.log(data);
      });
  }

  addFullName() {
    this.datatable = this.datatable.map(
      (item: { gfn: string; gln: string; fn: string; ln: string }) => ({
        ...item,
        fullName: item.fn + ' ' + item.ln,
        guardianName: item.gfn + ' ' + item.gln,
        rs: 'FW Pending',
      })
    );
    console.log(this.datatable, 'data');
  }

  cellComponentMap = {
    mk: SerialNoCellComponent,
  };

  onEnteringPincode() {
    const pincode = this.keywordSearchForm.get('pinCode')?.value;
    console.log(pincode);

    if (pincode != null && pincode != '') {
      this.isStateReadonly = true;
      this.isDistrictReadonly = true;
      if (pincode && pincode.length === 6) {
        let pincodeData: string = this.keywordSearchForm.get('pinCode')?.value;
        this._pincodeDetails.fetchPincodeDetails(pincodeData).subscribe({
          next: (response: PincodeDetailsData) => {
            // this.keywordSearchForm.controls['dikshyarthiDistrict'].setValue(
            //   response.data.districts
            // );

            console.log(response.data.districts);

            if (response.data.districts.length > 1) {
              this.isDistrictReadonly = false;
              this.keywordSearchForm.patchValue({
                state_name: response.data.states[0],
              });

              this.districtList = [];

              response.data.districts.forEach((elm: any) => {
                this.districtList.push({
                  district_name: elm,
                });

                console.log(this.districtList);
              });
            } else {
              this.getDistrictListFromPincode(response.data.states[0]);
              this.isDistrictReadonly = true;
              this.keywordSearchForm.patchValue({
                district_name: response.data.districts[0],
                state_name: response.data.states[0],
              });
            }
          },
          error: (error) => {
            console.log(error);
          },
        });
      }
    } else if (pincode == null || pincode == '') {
      this.isStateReadonly = false;
      this.isDistrictReadonly = false;
    }
  }

  onclickClear() {
    this.datatable = [];
    this.ritwikNames = [];
    this.districtList = [];

    this.keywordSearchForm.patchValue({
      firstName: '',
      middleName: '',
      lastName: '',
      guardian_first_name: '',
      guardian_middle_name: '',
      guardian_last_name: '',
      ritwiki_first_name: '',
      ritwiki_middle_name: '',
      ritwiki_last_name: '',
      mship_date: '',
      pinCode: '',
      address: '',
      state_name: '',
      district_name: '',
      fullName: '',
    });
    // this.keywordSearchForm.reset();
    console.log(this.keywordSearchForm.value);
  }

  loadMoreData(isStart: boolean) {
    if (this.keywordSearchForm.valid) {
      if (isStart) {
        this.datatable = [];
        this.pageNo = 1;
        this.isLoader = true;
      } else {
        this.pageNo += 1;
      }

      this.keywordSearchForm.controls['pageNo'].setValue(this.pageNo);
      this.keywordSearchForm.controls['pageSize'].setValue(this.pageSize);

      let Ivdate = this.keywordSearchForm.controls['mship_date']?.value;

      if (Ivdate != '' && Ivdate != null) {
        this.keywordSearchForm.controls['mship_date'].setValue(
          formatDate(Ivdate, 'yyyy-MM-dd', 'en')
        );
      }
      console.log(this.keywordSearchForm.value);
      let keywordSearchpayload: KeywordSearchRequest = this.keywordSearchForm
        .value as KeywordSearchRequest;

      this.keywordSearchService.getSearchData(keywordSearchpayload).subscribe({
        next: (response: any) => {
          if (
            response?.data?.memberList != null ||
            response?.data?.memberList != undefined
          ) {
            this.isLoader = false;
            console.log(response.data.memberList);
           
            this.datatable = [
              ...this.datatable,
              ...response?.data?.memberList.map((user: any) => {
                this.statusArray.filter((elm: any) => {
                  if (elm.status_code == user.rs) {
                    user.rs = elm.status_desc;
                  }
                });

                return {
                  mk: user.mk,
                  fullName: user.fn + ' ' + user.ln,
                  dn: user.dn,
                  rs: user.rs,
                  guardianName: user.gfn + ' ' + user.gln,
                  md: user.md,
                  rn: user.rn,
                  pn: user.pn,
                  add: user.add,
                  st: user.st,
                };
              }),
            ];
            console.log(this.datatable);
            // this.addFullName();
          } else if (isStart) {
            this.isLoader = false;
            this.snackbar.snackbar('Nothing to show', 'ok', 'success-snackbar');
          }
        },
        error: (error: any) => {
          // this.isLoading = false;
          this.isLoader = false;
          this.snackbar.snackbar(error, 'ok', 'success-snackbar');
          console.log(error);
        },
      });
    } else {
      this.formValidationError = true;
    }
  }
  onSearchMobileView()
  {
    if (this.keywordSearchForm.valid) {
    let keywordSearchpayload: KeywordSearchRequest = this.keywordSearchForm
        .value as KeywordSearchRequest;
        this._bottomSheet.open(KeywordMobileViewPopupComponent, {
          data: {
            keywordSearchpayload: keywordSearchpayload,
            width: '100vw',
            maxWidth: '100vw',
          },
        });
      }

  }

  searchRitwikName(rtname: string) {
    let nameofrt;

    this.ritwikTransmissionService.getRitwikListV2(rtname).subscribe({
      next: (response: any) => {
        if (!response.error) {
          nameofrt = response.data;
          this.ritwikNames = response.data.map(
            (items: { dwd_worker_name: any }) => items.dwd_worker_name
          );
        }
      },
      error: (error) => {
        console.log(error);
      },
    });

    return nameofrt;
  }

  onClickRowData(event: any) {
    console.log(event, 'event');
    this.keywordSearchService
      .getSlDetails(event.mk, { state: event.st })
      .subscribe({
        next: (response) => {
          if (!response.error && response.data.length == 1) {
            this.dialog.open(SearchStatusPopupComponent, {
              data: { data: response.data[0], status: event.rs },
            });
          }
        },
        error: (error) => {
          // this.toaster.error(error);
          this.snackbar.snackbar(error, 'ok', 'error-snackbar');
        },
      });
  }

  automatedDropVal(val: string) {
    this.isReadonly = true;
    this.keywordSearchForm.controls['ritwiki_first_name'].setValue('');
    this.keywordSearchForm.controls['ritwiki_middle_name'].setValue('');
    this.keywordSearchForm.controls['ritwiki_last_name'].setValue('');
    console.log(val);
    let names = val.split(' ');

    console.log(names);

    if (names.length == 1) {
      this.keywordSearchForm.controls['ritwiki_first_name'].setValue(names[0]);
    } else if (names.length == 2) {
      this.keywordSearchForm.controls['ritwiki_first_name'].setValue(names[0]);
      this.keywordSearchForm.controls['ritwiki_last_name'].setValue(names[1]);
    } else {
      this.keywordSearchForm.controls['ritwiki_first_name'].setValue(names[0]);
      this.keywordSearchForm.controls['ritwiki_middle_name'].setValue(names[1]);
      this.keywordSearchForm.controls['ritwiki_last_name'].setValue(
        names[names.length - 1]
      );
    }
  }

  getStatesDistrictList() {
    this.stateTransmissionService.getStatesList().subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;

          resp.forEach((elm: any) => {
            this.stateList.push(elm);
          });
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getDistrictList(event: any) {
    // console.log(event.target.value);
    this.districtTransmissionService.getDistrictList(event.value).subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;
          this.districtList = [];
          resp.forEach((elm: any) => {
            this.districtList.push(elm);
            console.log(this.districtList);
          });
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getDistrictListFromPincode(state: string) {
    // console.log(event.target.value);
    this.districtTransmissionService.getDistrictList(state).subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;

          if (resp.length > 1) {
            this.districtList = [];
            resp.forEach((elm: any) => {
              this.districtList.push(elm);
            });
          }
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  onCellClick(event: any) {
    this.serialNo.emit(event);
  }

}
